// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-spacer {
    flex: 1 1 auto;
  }
 .logo {
   height: 35px;
 }
 .mat-toolbar-row, .mat-toolbar-single-row {
  height: 50px;
  z-index: 2004;
}
.mat-toolbar-multiple-rows {
  min-height: 50px;
  border-bottom: 1px #eee solid;
}
 .profile-btn {
    width: 80px !important;
  }
.profile-name {
      background-color: #003561;
      color: #fff;
      max-width: 35px;
      height: 35px;
      padding: 0px;
      margin: 0px;
      min-width: 35px;
      border-radius: 50px;
      line-height: 36px;
      text-align: center;
  }
.mat-select-arrow {
  right: 0px !important;
} 
.nav-btn {
    padding-right: 20px;
    font-family: 'Inter Regular';
    color: #003561;
    letter-spacing: 1px;
}
.mat-select-arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid;
    float: right;
    position: absolute;
    right: 5px;
    top: 17px;
}


td, th {
  width: 25%;
}

table.mat-table {
  width: 100%;
  font-family:Roboto, "Helvetica Neue", sans-serif;
}
.mlr-15 {
  margin-left: -15px;
  margin-right: -15px;
}
::ng-deep .mat-table thead {
  background-color: #F1F9FF;
  letter-spacing: 1px;
  font-family:Roboto, "Helvetica Neue", sans-serif;
}
.mat-elevation-z8 {
  box-shadow: 
  0 0px 2px 0px rgba(0,0,0,.05),
  0 0px 2px 0px rgba(0,0,0,.05),
  0 0px 2px 0px rgba(0,0,0,.05) !important;
}
::ng-deep .mat-cell.cdk-column-star {
  width: 35px;
  text-align: right;
}
.mat-header-cell {
  color: #8f9cb3 !important;
}
.mat-cell, .mat-footer-cell {
  color: #555e6f !important;
  letter-spacing: 1px;
  min-width: 150px;
}
.mr-15 {
  margin-right: 15px;
}
.my-data-content {
  margin: 15px;
}
.p-0 {
  padding: 0px 15px;
}
.p-10 {
  padding: 10px;
}
.mat-icon.notranslate.material-icons.mat-icon-no-color {
  border: 1px #eaedf3 solid !important;
  border-radius: 50px !important;
  padding: 4px 4px !important;
  text-align: center !important;
}

a {
  color: #003561;
}
.width-100 {
width: 100%;
}
.mb-70 {
margin-bottom: 70px;
}
.pb-20 {
padding-bottom: 20px;
}
.header-list {
margin-left: -15px;
margin-right: -15px;
padding: 0px 20px 15px 20px;
border-bottom: 1px #e6e6e6 solid;
align-items: center !important;
padding-bottom: 0px;
}
h3 {
margin: 0px;
font-weight: normal;
letter-spacing: 0.5px;
font-size: 18px;
color: #003561;
font-family: 'Inter Regular';
font-weight: 500;
}
.filter-field ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline {
background-color: #ddd !important;
}
.float-left {
float: left;
padding-top: 7px;
}
.map-link {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  max-width: 95%;
  word-break: break-all;
}
tr.mat-row:hover {
  background: #FAF8F9;
}
.shared-text {
  font-size: 12px;
  color: #999;
  margin: 5px 0px;
  float: left;
  white-space: nowrap;
  width: 90%;
}
.link-text {
  font-style: italic;
  color: #ACB7C8;
  width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
}
.shared-show {
  position: relative;
}
.shared-show .mat-stroked-button {
  padding: 0 7px;
  line-height: 26px;
  font-size: 12px;
  letter-spacing: 1px;
  float: left;
  color: #003561;
  display: none;
  background-color: #fff;
  right: 0px;
  margin-top: -3px;
  position: absolute;
}
/*developer row color ---> background-color: #FAF8F9; */`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/business-user-dashboard/business-user-dashboard.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;EAChB;CACD;GACE,YAAY;CACd;CACA;EACC,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;CACC;IACG,sBAAsB;EACxB;AACF;MACM,yBAAyB;MACzB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,YAAY;MACZ,WAAW;MACX,eAAe;MACf,mBAAmB;MACnB,iBAAiB;MACjB,kBAAkB;EACtB;AACF;EACE,qBAAqB;AACvB;AACA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE;;;0CAGwC;AAC1C;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;AACA;AACA,WAAW;AACX;AACA;AACA,mBAAmB;AACnB;AACA;AACA,oBAAoB;AACpB;AACA;AACA,kBAAkB;AAClB,mBAAmB;AACnB,2BAA2B;AAC3B,gCAAgC;AAChC,8BAA8B;AAC9B,mBAAmB;AACnB;AACA;AACA,WAAW;AACX,mBAAmB;AACnB,qBAAqB;AACrB,eAAe;AACf,cAAc;AACd,4BAA4B;AAC5B,gBAAgB;AAChB;AACA;AACA,iCAAiC;AACjC;AACA;AACA,WAAW;AACX,gBAAgB;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA,uDAAuD","sourcesContent":[".menu-spacer {\n    flex: 1 1 auto;\n  }\n .logo {\n   height: 35px;\n }\n .mat-toolbar-row, .mat-toolbar-single-row {\n  height: 50px;\n  z-index: 2004;\n}\n.mat-toolbar-multiple-rows {\n  min-height: 50px;\n  border-bottom: 1px #eee solid;\n}\n .profile-btn {\n    width: 80px !important;\n  }\n.profile-name {\n      background-color: #003561;\n      color: #fff;\n      max-width: 35px;\n      height: 35px;\n      padding: 0px;\n      margin: 0px;\n      min-width: 35px;\n      border-radius: 50px;\n      line-height: 36px;\n      text-align: center;\n  }\n.mat-select-arrow {\n  right: 0px !important;\n} \n.nav-btn {\n    padding-right: 20px;\n    font-family: 'Inter Regular';\n    color: #003561;\n    letter-spacing: 1px;\n}\n.mat-select-arrow {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid;\n    float: right;\n    position: absolute;\n    right: 5px;\n    top: 17px;\n}\n\n\ntd, th {\n  width: 25%;\n}\n\ntable.mat-table {\n  width: 100%;\n  font-family:Roboto, \"Helvetica Neue\", sans-serif;\n}\n.mlr-15 {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n::ng-deep .mat-table thead {\n  background-color: #F1F9FF;\n  letter-spacing: 1px;\n  font-family:Roboto, \"Helvetica Neue\", sans-serif;\n}\n.mat-elevation-z8 {\n  box-shadow: \n  0 0px 2px 0px rgba(0,0,0,.05),\n  0 0px 2px 0px rgba(0,0,0,.05),\n  0 0px 2px 0px rgba(0,0,0,.05) !important;\n}\n::ng-deep .mat-cell.cdk-column-star {\n  width: 35px;\n  text-align: right;\n}\n.mat-header-cell {\n  color: #8f9cb3 !important;\n}\n.mat-cell, .mat-footer-cell {\n  color: #555e6f !important;\n  letter-spacing: 1px;\n  min-width: 150px;\n}\n.mr-15 {\n  margin-right: 15px;\n}\n.my-data-content {\n  margin: 15px;\n}\n.p-0 {\n  padding: 0px 15px;\n}\n.p-10 {\n  padding: 10px;\n}\n.mat-icon.notranslate.material-icons.mat-icon-no-color {\n  border: 1px #eaedf3 solid !important;\n  border-radius: 50px !important;\n  padding: 4px 4px !important;\n  text-align: center !important;\n}\n\na {\n  color: #003561;\n}\n.width-100 {\nwidth: 100%;\n}\n.mb-70 {\nmargin-bottom: 70px;\n}\n.pb-20 {\npadding-bottom: 20px;\n}\n.header-list {\nmargin-left: -15px;\nmargin-right: -15px;\npadding: 0px 20px 15px 20px;\nborder-bottom: 1px #e6e6e6 solid;\nalign-items: center !important;\npadding-bottom: 0px;\n}\nh3 {\nmargin: 0px;\nfont-weight: normal;\nletter-spacing: 0.5px;\nfont-size: 18px;\ncolor: #003561;\nfont-family: 'Inter Regular';\nfont-weight: 500;\n}\n.filter-field ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline {\nbackground-color: #ddd !important;\n}\n.float-left {\nfloat: left;\npadding-top: 7px;\n}\n.map-link {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  max-width: 95%;\n  word-break: break-all;\n}\ntr.mat-row:hover {\n  background: #FAF8F9;\n}\n.shared-text {\n  font-size: 12px;\n  color: #999;\n  margin: 5px 0px;\n  float: left;\n  white-space: nowrap;\n  width: 90%;\n}\n.link-text {\n  font-style: italic;\n  color: #ACB7C8;\n  width: 75%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border: none;\n}\n.shared-show {\n  position: relative;\n}\n.shared-show .mat-stroked-button {\n  padding: 0 7px;\n  line-height: 26px;\n  font-size: 12px;\n  letter-spacing: 1px;\n  float: left;\n  color: #003561;\n  display: none;\n  background-color: #fff;\n  right: 0px;\n  margin-top: -3px;\n  position: absolute;\n}\n/*developer row color ---> background-color: #FAF8F9; */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
